import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteMeal } from '../../../redux/slices/admin/mealsSlice';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import deleteIcon from '../../../images/icon-trash.svg';
import { confirmAlert } from 'react-confirm-alert';
import { Link } from 'react-router-dom';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

const MealsTable = ({ onEdit, onDelete, handlePageChange }) => {
  const dispatch = useDispatch();
  const { meals, currentMealPage, totalMealPages } = useSelector((state) => state.admin_meals);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  
  const toggleDropdown = (id, event) => {
    if (activeDropdown === id) {
      setActiveDropdown(null);
    } else {
      const rect = event.target.getBoundingClientRect();
      setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
      setActiveDropdown(id);
    }
  };

  const handleDeleteMeal = (mealId) => {
    confirmAlert({
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this meal?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => dispatch(deleteMeal(mealId))
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-toggle') && !event.target.closest('.dropdown-menu')) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

   const handleScroll = () => {
    setActiveDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <>
    <div className="table-responsive">
      <table className="table table-striped table-users table-alex printarea">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Calories</th>
            <th>Ingredients</th>
            <th className="noprint">Manage</th>
          </tr>
        </thead>
        <tbody>
          {meals && meals.length > 0 ? (
            meals.map((meal) => (
              <tr key={meal.id}>
                <td>
                  <div className="text-start d-flex align-items-center">
                    <div className="img-placeholder me-2">
                      {meal.meal_picture_full_url ? (
                        <img src={meal.meal_picture_full_url} alt={meal.meal_name || 'Meal'} className="img-thumbnail" />
                      ) : (
                        <p>No Image</p>
                      )}
                    </div>
                    <span>{meal.meal_name || 'Default Meal Name'}</span>
                  </div>
                </td>
                <td>
                  {meal.meal_type_name && <div>{meal.meal_type_name}</div>}
                </td>
                <td>
                  {meal.calories && <div>{meal.calories} kcal</div>}
                </td>
                <td>
                  <Link class="btn btn-create w-10" to={`/admin/manage-ingredients/${meal.id}`}>Manage</Link>
                </td>
                <td className="noprint">
                  <div className="dropdown">
                    <button 
                        type="button" 
                        className="bg-transparent border-0 p-0 btn-vert-dots" 
                        onClick={(e) => toggleDropdown(meal.id, e)}
                      >
                        <img src={optionsIcon} alt="Options" />
                      </button>

                    {activeDropdown === meal.id && (
                       <ul className="dropdown-menu dropdown-menu-end" 
                      style={{  display: 'block',
                            position: 'fixed',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            width: `200px`,
                            zIndex: 1050, }}
                      >  

                        <li>
                          <a className="dropdown-item" onClick={() => onEdit(meal)}>
                            <img src={editIcon} alt="Edit" /> Edit
                          </a>
                        </li>

                        {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                        <li>
                          <a className="dropdown-item" href="#" onClick={() => handleDeleteMeal(meal.id)}>
                            <img src={deleteIcon} alt="Delete" /> Delete
                          </a>
                        </li>
                        )}

                      </ul>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-center">No meals available.</td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
      <Pagination 
        currentPage={currentMealPage} 
        totalPages={totalMealPages} 
        onPageChange={handlePageChange} 
      />
    </>
  );
};

export default MealsTable;